import React from 'react';

import InventoryItem from '../InventoryItem';
import { IQuality } from 'types/qualities';
import PossessionsContext from 'components/Possessions/PossessionsContext';

export default function InventoryGroupComponent({
  name,
  qualities,
}: Props) {
  return (
    <div
      className="inventory-group"
      data-group-name={name}
    >
      <h2 className="heading heading--2 quality-group__name">{name}</h2>
      <PossessionsContext.Consumer>
        {({ currentlyInStorylet }) => (
          <ul className="items items--inline quality-group__items">
            {qualities.map((quality: IQuality) => (
              <InventoryItem
                currentlyInStorylet={currentlyInStorylet}
                key={quality.id}
                data={quality}
              />
            ))}
          </ul>
        )}
      </PossessionsContext.Consumer>
    </div>
  );
}

interface Props {
  name: string,
  qualities: IQuality[],
}

/*
InventoryGroupComponent.propTypes = {
  name: PropTypes.string.isRequired,
  qualities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
 */